import { useState } from 'react';

export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What is arranged marriage clarity guidance?',
      answer: 'Arranged marriage clarity guidance helps you understand and evaluate your potential arranged marriage partner. We focus on helping you gain clarity about compatibility, values, and expectations through structured sessions and expert consultation. This is about development through clarity, not relationship advice.'
    },
    {
      question: 'How are clarity sessions different from relationship counseling?',
      answer: 'Clarity sessions focus specifically on helping you understand your potential arranged marriage partner before marriage. We help you ask the right questions, identify important factors, and gain clarity about compatibility. We do not provide relationship advice or counseling for existing relationships.'
    },
    {
      question: 'Who can benefit from these clarity services?',
      answer: 'Anyone considering an arranged marriage who wants clarity about their potential partner can benefit. While we primarily serve the Indian market, our services are available worldwide. Whether you are in the early stages of meeting someone or closer to making a decision, our clarity guidance can help.'
    },
    {
      question: 'What is the difference between the Process, Nuanced, and Detailed courses?',
      answer: 'The Process Course covers the fundamental framework for gaining clarity in arranged marriage decisions. The Nuanced Course dives deeper into subtle complexities and evaluation techniques. The Detailed Course provides comprehensive advanced analysis and clarity methodologies. Each builds upon the previous level.'
    },
    {
      question: 'How do the 1-on-1 clarity sessions work?',
      answer: 'Our 1-on-1 clarity sessions are personalized consultations tailored to your specific situation. You can choose from Monthly, Fortnightly, Weekly, or Bi-weekly reviews based on your needs. Each session focuses on helping you gain clarity about your potential arranged marriage partner through structured guidance and expert insights.'
    },
    {
      question: 'Can I ask questions during live sessions?',
      answer: 'Yes! During our live sessions, you can ask questions about arranged marriage clarity. We also have an AI assistant available 24/7 to answer your questions. Check the live status indicator on our website to see when we are live for real-time Q&A sessions.'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white via-rose-50/30 to-white">
      <div className="max-w-4xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-6">
            <div className="flex items-center gap-2 px-4 py-2 bg-rose-100 rounded-full">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-question-line text-xl text-rose-800"></i>
              </div>
              <span className="text-sm font-semibold text-rose-800 uppercase tracking-wide">FAQ</span>
            </div>
          </div>

          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900" style={{ fontFamily: "'Cinzel', serif" }}>
            Frequently Asked <strong className="text-rose-800">Questions</strong>
          </h2>
          <p className="text-xl text-gray-600">
            Common questions about our <strong className="text-rose-700">arranged marriage clarity</strong> services
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl border-2 border-rose-100 overflow-hidden hover:border-rose-300 transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between gap-4 text-left cursor-pointer hover:bg-rose-50/50 transition-colors"
              >
                <h4 className="text-lg font-bold text-gray-900 flex-1">
                  {faq.question}
                </h4>
                <div className={`w-8 h-8 flex items-center justify-center bg-rose-100 rounded-full flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-xl text-rose-800"></i>
                </div>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}
              >
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Help */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">Still have questions?</p>
          <button
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="inline-flex items-center gap-2 px-6 py-3 bg-white text-rose-800 border-2 border-rose-800 rounded-full font-semibold hover:bg-rose-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-chat-4-line text-lg"></i>
            </div>
            Ask AI Assistant
          </button>
        </div>
      </div>
    </section>
  );
}
